import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../../../core/app.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalComponent } from '../../../../../components/modal/modal.component';
import { UiTable } from '../../../../../components/ui/table/table.component';
import { Input } from '../../../../../components/forms/input/input';
import { TableSourceFinancement } from '../../../../../data/schemas/table.schema';
import { UiButtonComponent } from '../../../../../components/button/button.component';
import { loaderIntervantion } from '../../../../../components/ui/loaderIntervantion/loaderIntervantion.component';
import { ConfirmDialogComponent } from '../../../../../components/ui/Confirmdialog/Confirmdialog.component';

@Component({
  selector: 'app-financement',
  standalone: true,
  imports: [
    UiTable,
    ModalComponent,
    ReactiveFormsModule,
    Input,
    UiButtonComponent,
    loaderIntervantion,
    ConfirmDialogComponent
  ],
  templateUrl: './financement.component.html',
  styleUrl: './financement.component.css'
})
export class FinancementPage implements OnInit {

  public tableSourceFinancement = TableSourceFinancement;
  public showAddSourceFinancementModal: boolean = false;
  public sourceFinancements: any[] = [];
  public isLoading: boolean = false;
  public isEditing: boolean = false;
  public editingSourceFinancement: any | null = null;

  // Confirmation suppression
  public showDeleteConfirm: boolean = false;
  public selectedItem: any | null = null;
  public deleteLoading: boolean = false;

  sourceFinancementForm!: FormGroup;

  constructor(
    private appService: AppService,
    private fb: FormBuilder
  ) {
    this.sourceFinancementForm = this.fb.group({
      applicationId: this.appService.getAppId(),
      libelle: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.loadSourceFinancements();
  }

  loadSourceFinancements(): void {
    // À implémenter avec votre service
  }

  saveSourceFinancement(): void {
    if (this.sourceFinancementForm.valid) {
      const appId = this.appService.getAppId();
      if (!appId || appId === 'null') return;

      this.isLoading = true;
      const requestBody = { ...this.sourceFinancementForm.value, applicationId: appId };

      if (this.isEditing && this.editingSourceFinancement) {
        // this.sourceFinancementService.update(this.editingSourceFinancement.id, requestBody).subscribe({
        //   next: () => { this.loadSourceFinancements(); this.closeSourceFinancementModal(); this.isLoading = false; },
        //   error: (e) => { console.error(e); this.isLoading = false; }
        // });
      } else {
        // this.sourceFinancementService.create(requestBody).subscribe({
        //   next: () => { this.loadSourceFinancements(); this.closeSourceFinancementModal(); this.isLoading = false; },
        //   error: (e) => { console.error(e); this.isLoading = false; }
        // });
      }
    } else {
      this.sourceFinancementForm.markAllAsTouched();
    }
  }

  onEditSourceFinancement(item: any): void {
    this.isEditing = true;
    this.editingSourceFinancement = item;
    this.sourceFinancementForm.patchValue({
      libelle: item.libelle,
      applicationId: this.appService.getAppId()
    });
    this.showAddSourceFinancementModal = true;
  }

  openSourceFinancementModal(): void {
    this.isEditing = false;
    this.editingSourceFinancement = null;
    this._resetForm();
    this.showAddSourceFinancementModal = true;
  }

  closeSourceFinancementModal(): void {
    this.showAddSourceFinancementModal = false;
    this.isEditing = false;
    this.editingSourceFinancement = null;
    this._resetForm();
  }

  openDeleteConfirm(item: any): void {
    this.selectedItem = item;
    this.showDeleteConfirm = true;
  }

  cancelDelete(): void {
    this.showDeleteConfirm = false;
    this.selectedItem = null;
  }

  confirmDelete(): void {
    if (!this.selectedItem) return;
    this.deleteLoading = true;
    // this.sourceFinancementService.delete(this.selectedItem.id).subscribe({
    //   next: () => { this.loadSourceFinancements(); this.deleteLoading = false; this.cancelDelete(); },
    //   error: (e) => { console.error(e); this.deleteLoading = false; }
    // });
  }

  private _resetForm(): void {
    this.sourceFinancementForm.reset({
      applicationId: this.appService.getAppId(),
      libelle: ''
    });
  }
}